export default __webpack_public_path__ + "0ac61ec9d9cc833168bd99eac5c67457.png";